import vue from 'vue'

const state = {
  isReady: false
}

const mutations = {
  PRINT_SET_FIELD(state, { field, value }) {
    vue.set(state, field, value)
  }
}

export default {
  state,
  mutations
}
